<div class="wrapper">
    <!-- start .row -->
    <div class="row">
        <div class="col-sm-12 wtw-hero-image">
            <img id="BGprincipal" class="img-responsive" src="./assets/global/images/cabeceras/bg_admin_auditoria.jpg">
            <h1 class="wtw-bg-black col-lg-5" style="margin-left: 15px">Administración</h1>
        </div>
    </div>
    <!-- end .row -->

    <div class="container-fluid">

        <!-- Page-Title -->
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="btn-group pull-right">
                        <ol class="breadcrumb hide-phone p-0 m-0">
                            <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                            <li class="breadcrumb-item"><a href="#">Administración</a></li>
                            <li class="breadcrumb-item"><a href="#">Paramétricas</a></li>
                            <li class="breadcrumb-item"><a href="#">Categorías</a></li>
                        </ol>
                    </div>
                    <h4 class="page-title">Administración Paramétricas</h4>
                </div>
            </div>
        </div>
        <!-- end page title end breadcrumb -->

        <div class="row">
            <div class="col-lg-6" *ngIf="!frameCategoria">
                <div class="card-box">
                    <h4 class="header-title mb-3">Información Categorías</h4>
                    <div class="table-responsive">
                        <table
                            class="table table-hover m-0 table-centered tickets-list table-actions-bar dt-responsive nowrap"
                            cellspacing="0" width="100%" id="datatableInfCat">
                            <thead>
                                <tr>
                                    <th>Ver</th>
                                    <th>Tipo de Categoría</th>
                                    <th>Modificar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of ListCategorias">
                                    <td><a (click)="listCategorias(item.idAdmTipoCategoria,item.nombre)"
                                            class="btn btn-sm btn-info"><i class="mdi mdi-eye-outline"></i></a></td>
                                    <td>{{item.nombre}}</td>
                                    <td><a (click)="editarTipoCategoria(item.nombre,item.idAdmTipoCategoria)"
                                            class="btn btn-sm btn-purple"><i class="mdi mdi-table-edit"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-lg-6" *ngIf="frameCategoria">
                <div class="card-box">
                    <h4 class="header-title mb-3">Variables Categoría</h4>
                    <div class="table-responsive">
                        <table
                            class="table table-hover m-0 table-centered tickets-list table-actions-bar dt-responsive nowrap"
                            cellspacing="0" width="100%" id="datatableCat">

                            <thead>
                                <tr>
                                    <th>Categoría</th>
                                    <th>Modificar</th>
                                    <th>Eliminar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of ListCategoriasByTipo">
                                    <td>{{item.nombre}}</td>
                                    <td><a (click)="editarCategoria(item.nombre,item.idAdmCategoria)"
                                            class="btn btn-sm btn-purple"><i class="mdi mdi-pencil"></i></a>
                                    </td>
                                    <td><a (click)="deleteCategoria(item.idAdmCategoria)" class="btn btn-sm btn-danger"><i
                                                class="mdi mdi-delete"></i></a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-lg-6" *ngIf="!edit">
                <div class="card-box">
                    <h4 class="m-t-0 header-title">Editar Tipo Categoria</h4>

                    <form [formGroup]="formTipoCategoria">
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <label for="nombreTipo">Tipo Categoría<span class="text-danger">*</span></label>
                                <input type="text" formControlName="nombre" 
                                    class="form-control" id="nombreTipo" ng-disabled="!editTipoCategoria">
                            </div>
                            <div class="actions clearfix">
                                <button type="button" (click)="updateTipoCategoria()"
                                    class="btn btn-custom waves-effect waves-light">
                                    <i class="fi-plus"></i>Modificar Tipo Categoría
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-lg-6" *ngIf="edit">
                <div class="card-box">
                    <h4 class="m-t-0 header-title">Agregar Categorías</h4>

                    <form [formGroup]="formCategoria">
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <label for="nombreCat">Tipo Categoría<span class="text-danger">*</span></label>
                                <input type="text" formControlName="nombreCat" 
                                    class="form-control" id="nombreCat" readonly>
                            </div>
                            <div class="form-group col-md-12">
                                <label for="nombre">Descripción Categoría<span class="text-danger">*</span></label>
                                <input type="text" formControlName="nombre" 
                                    class="form-control" id="nombre">
                            </div>
                            <div class="actions clearfix">
                                <div class="col-md-3">
                                    <button *ngIf="!editCategoria" type="button" (click)="onSubmitCategoria()"
                                        class="btn btn-custom waves-effect waves-light">
                                        <i class="fi-plus"></i>Agregar Categoría
                                    </button>
                                    <button *ngIf="editCategoria" type="button" (click)="updateCategoria()"
                                        class="btn btn-custom waves-effect waves-light">
                                        <i class="fi-plus"></i>Editar Categoría
                                    </button>
                                </div>
                                <div class="col-md-3">
                                    <button *ngIf="btnAtras" type="button" (click)="cancelState()"
                                        class="btn btn-danger">
                                        <i class="less-than"></i>Atras
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div> <!-- end container -->
</div>
<!-- end wrapper -->
<div class="blanco"></div>